/* eslint-disable no-unused-expressions */
import React from 'react';
import './ManageControlDone.css';
import {Documents} from '../documents';
import {endsControlWithAfterControlNote, getPostControlDocuments} from '../documents/helpers';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Controls';
import * as actionsProg from '../../Redux/Actions/Programs';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as PropertyBucket from '../../Properties/Properties';
import * as ControlFunctions from '.././ManageControlCommons/ManageControlCommons';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import {UploadDocumentsPopup} from '../UploadDocumentsPopup/UploadDocumentsPopup';
import {RemarksPopup} from '../Remarks/RemarksDetail';
import SelectCustom from '../SelectCustom/SelectCustom';
import {getPostControlDocType} from '../../Helpers/utils';
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import {TableCustomTabs} from "../TableCustom/TableCustomTabs";
import {cloneDeep} from "lodash";
import Checkbox from '@mui/material/Checkbox';
import {downloadXLSXFile} from '../documents/helpers';
import {hasPermission} from "../ControlStateHelper";
import * as httpService from '../HttpService/HttpService';
import {EditControlSource} from "../../enums/editControlSource";

const tabs = ['Zrealizowane', 'Zakończone'];

class ManageControlDone extends React.Component {

	columnsDefault = [
		{title: 'Zakończone', field: 'completed', sorting: false, filtering: false, cellStyle: {textAlign: 'center'} },
		{title: 'Numer kontroli', field: 'number', cellStyle: { width: '305px', minWidth: '305px' }},
		{title: 'Data rozpoczęcia kontroli', field: 'dateStart', width: 80, cellStyle: {textAlign: 'center'}},//term
		{title: 'Beneficjent', field: 'beneficiary', minWidth: 120, className: 'beneficiary'},
		{title: 'Rodzaj kontroli', field: 'controlKind', width: 110},//kind
		{title: 'Typ kontroli', field: 'controlType', width: 120},//type
		{title: 'Tryb kontroli', field: 'controlMode', width: 90},//mode
		{title: 'Zespół kontrolujący', field: 'controllersDescription', minWidth: 130},
		{title: 'Zalecenia', field: 'followUpString', width: 90},//followUpString
		{title: 'Wdrożenie zaleceń', field: 'followUpStatus', width: 90},//followUpStatus
		{title: 'Data wysłania informacji ostatecznej', field: 'finalInfoSentDate', width: 90}//postControlInfoFinalIssueDate
	];
	previousInputFocusId = null;

	getColumnsForTab = (tab) => {
		const columns = cloneDeep(this.columnsDefault);
		if (tab === tabs[1]) {
			columns.push({title: 'Wynik kontroli', field: 'internalControlResult', width: 120});
		}
		return columns;
	};

	constructor(props) {
		super(props);
		this.state = {
			isWaiting: false,
			showPopup: false,
			showInfosListTab: false,
			showRemarksDetail: false,
			showDocumentsControl: null,
			selectedTab: tabs[0],
			filterChangeOnField: null,
			tabs: tabs.reduce((accumulator, value) => {
				return {...accumulator, [value]: {
					tablePageSize: 10,
					page: this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0,
					programSearch: "",
					quickSearch: "",
					filters: [],
					orderBy: "number",
					orderById: "",
					orderDirection: "asc",
				}};
			  }, {}),
			columns: this.getColumnsForTab(tabs[0]),
			documentTitle: 'e-Kontrole | Kontrole zrealizowane',
			hadFirstLoad: false
		};
		this.programmsDoneSelectRef = React.createRef();
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Kontrole zrealizowane";

		const newState = cloneDeep(this.state);
		if (this.props.controls.tableTab && this.props.controls.tableName === document.title) {
			newState.selectedTab = this.props.controls.tableTab;
		}
		if (this.props.controls.tableFilters.length && this.props.controls.tableName === document.title) {
			newState.columns = this.getDefaultFilters(newState.selectedTab);
			newState.tabs[newState.selectedTab].filters = this.props.controls.tableFilters;
		} else {
			newState.columns = this.getColumnsForTab(newState.selectedTab);
		}
		if (this.props.controls.tableQuickSearch && this.props.controls.tableName === document.title) {
			newState.tabs[newState.selectedTab].quickSearch = this.props.controls.tableQuickSearch;
		}
		if(this.props.match.params.pageNumber) {
			newState.tabs[newState.selectedTab].page = parseInt(this.props.match.params.pageNumber) - 1;
		}
		if (store.getState().programs.selected) {
			newState.tabs[tabs[0]].programSearch = [store.getState().programs.selected];
			newState.tabs[tabs[1]].programSearch = [store.getState().programs.selected];
		}
		this.setState(newState);
	}

	componentDidUpdate(prevState) {
		if (prevState.programs?.selected?.code !== this.props.programs?.selected?.code) {
			this.setValues([this.props.programs.selected]);
		}

		const {fetchControlData} = this.props;

		const newState = cloneDeep(this.state);

		if(this.state.hadFirstLoad === false && store.getState().controls.isManageDoneControlsLoading === false) {
			fetchControlData(newState.tabs[newState.selectedTab].page, ControlFunctions.getFilterParam(newState.tabs[newState.selectedTab].filters), [newState.tabs[newState.selectedTab].orderBy, newState.tabs[newState.selectedTab].orderDirection], newState.tabs[newState.selectedTab].programSearch, newState.tabs[newState.selectedTab].quickSearch, newState.tabs[newState.selectedTab].tablePageSize, newState.selectedTab === tabs[1], (e) => this.handleRedirect(e));
			this.setState({hadFirstLoad: true});
		}
	}

	handleRedirect = (e) => {
		if (e.totalPages <= this.state.tabs[this.state.selectedTab].page) {
			const newState = cloneDeep(this.state);
			newState.tabs[this.state.selectedTab].page = 0;
			this.setState(newState);
			this.props.history.push('/controls/done');
			const {fetchControlData} = this.props;
			fetchControlData(0, ControlFunctions.getFilterParam(this.state.tabs[this.state.selectedTab].filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], this.state.tabs[this.state.selectedTab].programSearch, this.state.tabs[this.state.selectedTab].quickSearch, this.state.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1]);
		}
	}

	getDefaultFilters = (tab) => {
		const columns = this.getColumnsForTab(tab);

		this.props.controls.tableFilters.forEach((filter, index) => {
			if (filter.filterValue) {
				columns[index].defaultFilter = filter.filterValue
			}
		});

		return columns;
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	setValues = (values) => {
		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(0);
		newState.tabs[tabs[0]].programSearch = values;
		newState.tabs[tabs[1]].programSearch = values;
		this.setState(newState);
		
		this.props.history.push('/controls/done');
		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.tabs[this.state.selectedTab].filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], values, this.state.tabs[this.state.selectedTab].quickSearch, this.state.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1]);

	};

	showPopup = (title, notification, type, onClickEvent) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent}
		})

	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	handleCloseQuest = () => {
		this.setState({showPopup: false});
	};

	onDetailButtonClick = (row) => {
		this.props.history.push('/controls/control_detail/' + row.id);
	};

	onListPreviewButtonClick = (row) => {
		this.props.history.push('/controls/control_list_detail/' + row.id);
	};

	onPostControlInfoRedirect = (row) => {
		this.props.history.push('/controls/post_control_info_detail/' + row.postControlDocuments[0].postControlInfo.infoId);
	};

	onPostControlNoteRedirect = (row) => {
		this.props.history.push('/controls/post_control_note_detail/' + row.postControlDocuments[0].postControlNote.noteId);
	};

	onEditButtonClick = (row) => {
		this.props.history.push(`/controls/edit_control/${row.id}/source/${EditControlSource.MANAGE_DONE}`);
	}

	onPostInfoPreviewButtonClick = async (row) => {
		if (row.postControlDocuments) {
			let documents = await getPostControlDocuments(row.id)
			const { setFiltersData } = this.props;
			setFiltersData({ filter: this.state.tabs[this.state.selectedTab].filters, tableName: this.state.documentTitle });
			const { setQuickSearchData } = this.props;
			setQuickSearchData({quickSearch: this.state.tabs[this.state.selectedTab].quickSearch, tableName: this.state.documentTitle, tab: this.state.selectedTab});
			this.showPopup('Dokumenty pokontrolne', ControlFunctions.displayInfosListTab(documents, row.number, row.id,'controls', () => {
				this.setState({
					record: row,
					documents: documents,
					isUploadDocsWindowVisible: true,
					showPopup: false,
					docType: getPostControlDocType(documents)
				});
			}), 'notify')
		} else {
			this.showPopup('Komunikat', 'Kontrola nie ma jeszcze dokumentu pokontrolnego.', 'notify')
		}
	};

	onFollowUpButtonClick = (row) => {
		if (row.followUp) {
			this.showPopup('Monitorowanie zaleceń', ControlFunctions.displayFollowUpInfo(row), 'notify')
		} else {
			this.showPopup('Komunikat', PropertyBucket.getNoFollowUpMessage(), 'notify')
		}
	};

	prepareData = (data) => {
		return data.map(ControlFunctions.setupControlData);
	};

	focusOnFilterElement(_this) {
		const field = _this.state.tabs[this.state.selectedTab].filters.find(x => {
			if (this.state.filterChangeOnField) {
				return x.field === this.state.filterChangeOnField.field;
			} else {
				return x.filterValue !== undefined;
			}
		});

		if (field) {
			const elements = document.getElementsByClassName('MuiInput-inputTypeSearch');
			let findInputToFocus = false;

			for (let i = 0; i < elements.length; i++) {
				if (elements[i].value.length && elements[i].value === field.filterValue) {
					elements[i].focus();
					findInputToFocus = true;
					this.previousInputFocusId = i;
				}
			}

			if (!findInputToFocus && field.filterValue === '' && this.previousInputFocusId != null) {
				elements[this.previousInputFocusId].focus();
				this.previousInputFocusId = null;
			}
		}
	}

	onRemarksButtonClick = async (row) => {
		let documents = await getPostControlDocuments(row.id)
		const objectionExists = documents && documents[0]?.postControlInfo?.objection;
		if(objectionExists)	{
			this.setState({
				showRemarksDetail: true,
				documents: documents,
				record: row,
				showPopup: false
			});
		}
		else {
			this.showPopup('Komunikat', PropertyBucket.getNoPostControlRemarksMessage(), 'notify')
		}
	};

	handlePageChange(page, size) {
		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(page);
		newState.tabs[this.state.selectedTab].tablePageSize = size;
		this.setState(newState);

		const {fetchControlData} = this.props;
		fetchControlData(page, ControlFunctions.getFilterParam(this.state.tabs[this.state.selectedTab].filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], this.state.tabs[this.state.selectedTab].programSearch, this.state.tabs[this.state.selectedTab].quickSearch, size, this.state.selectedTab === tabs[1]);
	}

	handleFilterChange(filters) {
		this.state.tabs[this.state.selectedTab].filters.forEach((filterField, id) => {
			if (filterField.filterValue !== filters[id].filterValue) {
				this.setState({ filterChangeOnField: filters[id] });
			}
		});

		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(0);
		newState.tabs[this.state.selectedTab].filters = filters;
		this.setState(newState);

		this.props.history.push('/controls/done');

		const {fetchControlData, setFiltersData} = this.props;
		setFiltersData({ filter: filters, tableName: this.state.documentTitle });
		fetchControlData(0, ControlFunctions.getFilterParam(filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], this.state.tabs[this.state.selectedTab].programSearch, this.state.tabs[this.state.selectedTab].quickSearch, this.state.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1], () => this.focusOnFilterElement(this));
	}

	handleQuickSearchChange(search) {
		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(0);
		newState.tabs[this.state.selectedTab].quickSearch = search;
		this.setState(newState);

		this.props.history.push('/controls/done');

		const {fetchControlData, setQuickSearchData} = this.props;
		const focusOnQuickSearchInput = () => {
			const element = document.querySelector('[placeholder="Szukaj"]');
			element.focus();
		};
		setQuickSearchData({quickSearch: search, tableName: this.state.documentTitle, tab: this.state.selectedTab});
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.tabs[this.state.selectedTab].filters), [this.state.tabs[this.state.selectedTab].orderBy, this.state.tabs[this.state.selectedTab].orderDirection], this.state.tabs[this.state.selectedTab].programSearch, search, this.state.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1], focusOnQuickSearchInput);
	}

	handleOrderChange(column, order) {
		const orderColumn = (this.state.columns[column] ? this.state.columns[column].field :'')
		const newState = cloneDeep(this.state);
		newState.tabs[this.state.selectedTab].page = parseInt(0);
		newState.tabs[this.state.selectedTab].orderById = column;
		newState.tabs[this.state.selectedTab].orderBy = orderColumn;
		newState.tabs[this.state.selectedTab].orderDirection = order;
		this.setState(newState);

		this.props.history.push('/controls/done');

		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.tabs[this.state.selectedTab].filters), [orderColumn, order], this.state.tabs[this.state.selectedTab].programSearch, this.state.tabs[this.state.selectedTab].quickSearch, this.state.tabs[this.state.selectedTab].tablePageSize, this.state.selectedTab === tabs[1]);
	}

	handleTabChange(tab) {
		const newColumns = this.getColumnsForTab(tab);
		this.setState({selectedTab: tab, columns: newColumns});

		this.props.history.push(`/controls/done${this.state.tabs[tab].page > 0 ? `/${this.state.tabs[tab].page + 1}` : ''}`);
		const {fetchControlData, setTabData} = this.props;
		setTabData({quickSearch: this.state.tabs[tab].quickSearch, filter: this.state.tabs[tab].filters, tableName: this.state.documentTitle, tab: tab});
		fetchControlData(this.state.tabs[tab].page, ControlFunctions.getFilterParam(this.state.tabs[tab].filters), [this.state.tabs[tab].orderBy, this.state.tabs[tab].orderDirection], this.state.tabs[tab].programSearch, this.state.tabs[tab].quickSearch, this.state.tabs[tab].tablePageSize, tab === tabs[1]);
	}

	handleListDownload() {
		const date = new Date(Date.now()).toLocaleString().split(',')[0];
		const fileName = `Zarządzaj_kontrolami_Zrealizowane_${date}.xlsx`;
		downloadXLSXFile(fileName, 'Zrealizowana', this.state.orderBy, this.state.orderDirection);
	}

	addedCheckboxesForControls = (controls) => controls.map(c => ({...c, completed: (<Checkbox key={c.id} disabled checked={c.completed}/>)}));

	onDeleteButtonClick = (row) => {
		this.showPopup('Komunikat', PropertyBucket.deleteControlConfirmationMessage(row.number), 'confirm', () => {
			this.deleteControl(row)
		})
	};

	isDisableDelete = (data) => {
		return !hasPermission(data, "control.manage.delete");
	};

	isDisableEdit = (data) => {
		return !hasPermission(data, "control.manage.edit");
	};

	deleteControl = (record) => {
		this.isWaitingOnOff(true);
		let controlId = record.id;
		let url = PropertyBucket.deleteControl(controlId);
		let callPromise = httpService.getService(url, 'DELETE', null);
		let _this = this;

		callPromise.then(
			function (message) {
				_this.props.fetchControlData(0, ControlFunctions.getFilterParam(_this.state.tabs[_this.state.selectedTab].filters), [_this.state.tabs[_this.state.selectedTab].orderBy, _this.state.tabs[_this.state.selectedTab].orderDirection], _this.state.tabs[_this.state.selectedTab].programSearch, _this.state.tabs[_this.state.selectedTab].quickSearch, _this.state.tabs[_this.state.selectedTab].tablePageSize, _this.state.selectedTab === tabs[1]);
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', PropertyBucket.deleteControlMessage(), 'notify')
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error.message ? error.message : error, 'error')
			}
		)
	};

	render() {
		const { roleDetails } = this.props.userData.user;
		let userRole = roleDetails.role;
		let loadedControlsData;
		loadedControlsData = this.state.loadedControlsData ? this.state.loadedControlsData : store.getState().controls.manageDoneControls;
		loadedControlsData = this.addedCheckboxesForControls(loadedControlsData);
		let loadedProgsData;
		userRole === 'SA' ? loadedProgsData = store.getState().programs.programs : loadedProgsData = null;
		let table;
		let dropdown;
		let popUp;
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
			                title={this.state.popUp.title}
			                notification={this.state.popUp.notification}
			                link={this.state.popUp.link}
			                onClickEvent={this.state.popUp.onClickEvent}
			                closePopUp={this.handleClosePopUp}
			/>) : null;

		if (this.props.controls && this.props.controls.isManageDoneControlsLoading === false) {
			if (loadedControlsData.length >= 0) {
				let totalElements = 0
				if (loadedControlsData.length > 0) {
					totalElements = this.props.controls.filters.totalElements
				}
				this.prepareData(loadedControlsData);
				table = <TableCustomLazyLoading
					isActionsMultilines
					columns={ControlFunctions.getColumnsWithDefaultFilterValues(this.state.columns, this.state.tabs[this.state.selectedTab].filters)}
					data={loadedControlsData}
					orderBy={this.state.tabs[this.state.selectedTab].orderById}
					orderDirection={this.state.tabs[this.state.selectedTab].orderDirection}
					count={totalElements}
					page={this.state.tabs[this.state.selectedTab].page}
					actions={[
						rowData => ({
							icon: 'library_books',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1', margin: 0, padding: 0 } },
							tooltip: <span>Szczegóły kontroli<span className='sr-only'> {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDetailButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'editButton',
							iconProps: {
								style: {
									fontSize: '24px',
									color: this.isDisableEdit(rowData) ? '#ccc' : '#0d47a1'
								}
							},
							tooltip: <span>Edytuj<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onEditButtonClick(rowData);
							},
							disabled: this.isDisableEdit(rowData),
						}),
						rowData => {
							if (this.state.selectedTab === tabs[0]) {
								return {
									icon: 'delete',
									iconProps: {
										style: {
											fontSize: '24px',
											color: this.isDisableDelete(rowData) ? '#ccc' : '#0d47a1'
										}
									},
									tooltip: <span>Usuń <span
										className='sr-only'> kontrolę: {rowData.number || ''}</span></span>,
									onClick: (event, rowData) => {
										this.onDeleteButtonClick(rowData);
									},
									disabled: this.isDisableDelete(rowData)
								}
							}
							return null;
						},
						rowData => ({
							icon: 'find_in_page',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Podgląd listy<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onListPreviewButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'description',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Dokumenty pokontrolne<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onPostInfoPreviewButtonClick(rowData);
							},
						}),
						rowData => ({
							icon: 'message',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Zastrzeżenia<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onRemarksButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'library_add_check',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Monitorowanie zaleceń<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onFollowUpButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'folder',
							iconProps: {style: {fontSize: '24px', color: '#0d47a1'}},
							tooltip: <span>Pliki<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: async (event, rowData) => {
								let documents = await getPostControlDocuments(rowData.id)
								this.setState({endsControlWithAfterControlNote : endsControlWithAfterControlNote(documents)})
								this.setState({showDocumentsControl: rowData});
							},
						}),
					]}
					initialPage={this.props.match.params.pageNumber ?parseInt(this.props.match.params.pageNumber) - 1 : 0}
					pageSize={this.state.tabs[this.state.selectedTab].tablePageSize}
					onChangePage={
						(page, size) => {
							const newState = cloneDeep(this.state);
							newState.tabs[this.state.selectedTab].page = parseInt(page);
							newState.tabs[this.state.selectedTab].tablePageSize = parseInt(size);
							this.setState(newState);
							
							this.props.history.push(`/controls/done/${parseInt(page) + 1}`)
							this.handlePageChange(parseInt(page), parseInt(size))
						}
					}
					onFilterChange={(value) => {
						this.handleFilterChange(value)
					}}
					onQuickSearchChange={(value) => {
						this.handleQuickSearchChange(value)
					}}
					quickSearch={this.state.tabs[this.state.selectedTab].quickSearch}
					onOrderChange={(column, order) => {
						this.handleOrderChange(column, order)}
					}
					isTableForDoneControls={true}
					customTabs={<TableCustomTabs tabs={tabs} onTabChange={(e) => this.handleTabChange(e)} active={this.state.selectedTab}/>}
				/>;
			}
		}

		if (userRole === 'SA' && loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					labelField='code'
					placeholder='Programy'
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.tabs[this.state.selectedTab].previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.tabs[this.state.selectedTab].previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					id='programmsDoneSelectId'
					dropdownId='programmsDoneDropdownId'
					label='Programy'
					parentRef={this.programmsDoneSelectRef}
				/>
			</div>
		}

		const { showDocumentsControl: control } = this.state;
		return (
			<div id='control_search'>
				{this.state.isUploadDocsWindowVisible && <UploadDocumentsPopup
																isPossibleSendData={false}
																isPossibleChangeDate={this.state.docType === 'INF' ? true : false}
																control={this.state.record}
																showPopup={this.showPopup}
																handleLoading={this.isWaitingOnOff}
																handleClose={() => this.setState({
																	isUploadDocsWindowVisible: false,
																})}
																/>}
				{this.state.showRemarksDetail &&<RemarksPopup
													data= {this.state.record}
													documents={this.state.documents}
													closeWindow = {() => this.setState({
														showRemarksDetail: false,
														})}
													onlyPreview = {true}
												/>}
				{popUp}
				<div id='add_control'>
					<h2 className='mb-4 float-left'>Kontrole - Zrealizowane</h2>
					<Link to='/create_control' className='btn save-btn' id='plus_img_container'><i data-v-db6946bc=''
					                                                                               aria-hidden='true'
					                                                                               className='v-icon material-icons theme--light v-list-text'>add</i><span>UTWÓRZ KONTROLĘ</span></Link>
					<div className='clearfix'/>
				</div>
				<div>
					{userRole === 'SA' ? dropdown : null}
					<div id='controls_table' className={this.state.selectedTab === tabs[1] ? 'completed-controls' : ''}>
						<div style={{display: 'flex', flexDirection: 'column'}}>
							<button type='button' onClick={() => this.handleListDownload()} className='btn save-btn download-xlsx-btn'>
								<i data-v-db6946bc='' aria-hidden='true' className='v-icon material-icons theme--light v-list-text'>download</i><span>POBIERZ</span>
							</button>
							{table}
						</div>
					</div>
				</div>
				{control !== null &&
					<Documents
						controlUuid={control.uuid}
						endsWithAfterControlNote={this.state.endsControlWithAfterControlNote}
						hiddenButtons
						inPopup
						removingOnListForbidden
						withDocumentsList
						onCancel={() => this.setState({showDocumentsControl: null})}
					/>
				}
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.controls.isManageDoneControlsLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch, ownParams) => {
	let url = PropertyBucket.getControlsDone();
	let page = 0;
	if(ownParams.match.params.pageNumber) {
		page = (ownParams.match.params.pageNumber-1)
	}

	return {
		fetchControlData: (pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, completedParam, successCallback) => dispatch(actions.getControlData(url, page, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, completedParam, successCallback, 'manageDone')),
		setFiltersData: (filters) => dispatch(actions.setFiltersData(filters)),
		setQuickSearchData: (quickSearch) => dispatch(actions.setQuickSearchData(quickSearch)),
		setTabData: (tab)=> dispatch(actions.setTabData(tab))
	}
};
export const ManageControlDoneProvider = connect(mapStateToProps, mapDispatchToProps)(ManageControlDone);
